import React from 'react';
import Chart from 'react-apexcharts';

const AreaChart = ({graphData}) => {
  const options = {
    chart: {
      type: 'area',
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    colors: ["#FFD700"],
    width: [1],
    stroke: {
        curve: "straight",
        width: [1],
      },
      fill: {
        type: "solid",
        colors: ["#5c5c5c40"], // Light gray fill
      },
    xaxis: {
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    grid: { show: false },
    dataLabels: { enabled: false },
    stroke: { curve: 'smooth' },
    tooltip: { enabled: false },
    title: { text: undefined },
    subtitle: { text: undefined },
    legend: { show: false },
  };

  const series = [
    {
      name: 'Series 1',
      data: graphData,
    },
  ];

  return (
    <Chart options={options} series={series} type="area" height={200} />
  );
};

export default AreaChart;
